// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  unleash: {
    enabled: true,
    url: "https://ftx.hxa.io/api/frontend/",
    clientKey:
      "default:development.77878545718c1b30772bae87fbfa445f7f83c0d97eefda16c91ff538",
    appName: "hxa-portal-stg01",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
